// Determine if running on the server side (SSR / Node.js)
const isServer = typeof window === "undefined";

// Determine if running locally in a developer browser
const isLocalBrowser =
  !isServer &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// Server side (SSR) ALWAYS routes through https://api.buildwithjit.com.
// Client side in production always routes through https://api.buildwithjit.com.
// Local browser development connects to local backend or VITE_API_URL.
export const API_URL: string = isServer
  ? typeof process !== "undefined" && process.env && process.env["API_URL"]
    ? (process.env["API_URL"] as string)
    : "https://api.buildwithjit.com"
  : isLocalBrowser
    ? (import.meta.env as Record<string, string | undefined>)["VITE_API_URL"] ||
      "http://localhost:8000"
    : "https://api.buildwithjit.com";
